function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? Object(arguments[i]) : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys.push.apply(ownKeys, Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { createSelector } from 'reselect';
import { favouriteProductsStateSelector, favouriteProductIdsSelector, totalFavouritesLengthSelector, isLoadingFavouriteProductsSelector, isLoadingAllFavouriteProductIdsSelector } from 'swag-client-common/redux/favourite-products/favourite-products.selectors';
import { Price } from 'swag-client-common/utils/price';
import { featureTogglesSelector } from 'swag-client-common/redux/feature-toggles/feature-toggles.selectors';
import { itemSelector, limitedEditionSelector } from '../../components/page/components/product-card/product-card.selectors';
import { productSelector } from '../product/product.selectors';
const productItemPropsSelector = (state, props) => props.item;
const checkProductIsFavourite = (product, favouriteProductIds) => {
  if (!product) {
    return false;
  }
  return favouriteProductIds.has(product._id);
};
export const isProductFavouriteSelector = createSelector(productItemPropsSelector, favouriteProductIdsSelector, checkProductIsFavourite);
export const productAtProductBuilderIsFavouriteSelector = createSelector(productSelector, favouriteProductIdsSelector, checkProductIsFavourite);
export const pageSelector = createSelector(favouriteProductsStateSelector, state => state.page);
export const favouriteProductsSelector = createSelector(favouriteProductsStateSelector, featureTogglesSelector, (state, featureFlags) => state.favouriteProducts.map(product => {
  const edgePrices = Price.calculateDefaultEdgePrice({
    product,
    featureFlags
  });
  const {
    dynamicQuantityAndLocationsOptionsForDecorationMethods
  } = featureFlags;
  if (dynamicQuantityAndLocationsOptionsForDecorationMethods) {
    var _product$productSetti;
    const minQuantity = Math.min(...((product === null || product === void 0 ? void 0 : (_product$productSetti = product.productSettings) === null || _product$productSetti === void 0 ? void 0 : _product$productSetti.map(({
      minQuant
    }) => minQuant)) || [1]));
    return _objectSpread({}, product, {
      minPrice: edgePrices.minPrice,
      maxPrice: edgePrices.maxPrice,
      minQuant: minQuantity
    });
  }
  return _objectSpread({}, product, {
    minPrice: edgePrices.minPrice,
    maxPrice: edgePrices.maxPrice
  });
}));
const isFavouriteProductsPageInitializedSelector = createSelector(favouriteProductsStateSelector, state => state.isFavouriteProductsPageInitialized);
export const hasFavouriteProductsSelector = createSelector(isLoadingAllFavouriteProductIdsSelector, favouriteProductIdsSelector, (isLoadingAllFavouriteProductIds, favouriteProductIds) => !isLoadingAllFavouriteProductIds && favouriteProductIds.size > 0);
export const shouldShowEmptyBlockSelector = createSelector(hasFavouriteProductsSelector, isFavouriteProductsPageInitializedSelector, (hasFavourites, isFavouriteProductsPageInitialized) => {
  return !hasFavourites && isFavouriteProductsPageInitialized;
});
export const hasMoreFavouriteProductsSelector = createSelector(isLoadingFavouriteProductsSelector, totalFavouritesLengthSelector, favouriteProductsSelector, (isLoadingAllFavouriteProductIds, allFavouriteProductIdsLength, favouriteProducts) => {
  return !isLoadingAllFavouriteProductIds && allFavouriteProductIdsLength > favouriteProducts.length;
});
export const showProductLabelSelector = createSelector(itemSelector, limitedEditionSelector, ({
  productLabel
}, {
  isLimitedEdition
}) => {
  return !isLimitedEdition && productLabel;
});